// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__37l70","label":"Radio_label__2CeH9","checkMark":"Radio_checkMark__gwjTG","disabled":"Radio_disabled__2OXnd"};